import { FooterModule, HeaderModule } from '@acpaas-ui/ngx-components/layout';
import { LogoModule } from '@acpaas-ui/ngx-components/logo';

export const AUI_IMPORTS = [
	FooterModule,
	HeaderModule,
	LogoModule,
];
